export default __webpack_public_path__ + "static/media/60.54c1665b.jpg";